import { useEffect, useRef } from 'react';

export const useClickOutside = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        // Check if the click is on a Choices.js dropdown element
        const target = event.target as Element;
        if (target.closest('.choices__list--dropdown') || 
            target.closest('.choices__item--choice') ||
            target.closest('.choices')) {
          return; // Don't close modal if clicking on Choices.js elements
        }
        callback();
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback]);

  return ref;
};

export default useClickOutside;
